"use client"

import { useState } from "react";
import AppIcon from "../AppIcon";

interface MethodologyProps {
    content: string;
}

const Methodology = ({ content }: MethodologyProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div 
            className="bg-blue-100 rounded-t p-5 flex flex-col gap-5 cursor-pointer"
            onClick={toggleIsOpen}
        >
            <div className="flex items-center justify-between">
                <div className="font-semibold">
                    Méthodologie
                </div>
                <div className="font-semibold">
                    <AppIcon iconClassName={isOpen ? 'fa-minus' : 'fa-plus'} />
                </div>
            </div>

            <div className={`${isOpen ? 'block' : 'hidden'}`}>{content}</div>
        </div>
    );
};

export default Methodology


